export enum DiscoverPath {
  CLASSES = 'dcl',
  COURSES = 'dco',
  WORKSHOPS = 'dwo',
  EVENTS = 'dev',
  RETREATS = 'dre',
  EDUCATION = 'ded',
  CAMPS = 'dca',
  OPEN_TRAININGS = 'dotr',
  PUBLIC_MATCHES = 'matches',
}
